import React, { useState } from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const [hoveredProduct, setHoveredProduct] = useState(null);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <body className="color-scheme color-scheme--scheme-1">
      <Header />

      <main className="shop-page">
        <div className="shop-container">
          <div className="product-grid">
            {productData.map((product) => (
              <Link
                to={`/shopDetails/${product.id}`}
                key={product.id}
                className="product-card"
                onMouseEnter={() => setHoveredProduct(product.id)}
                onMouseLeave={() => setHoveredProduct(null)}
                onClick={toTop}
              >
                <div className="product-card__image-wrapper">
                  <img
                    src={product.images[0]}
                    alt={product.name}
                    className="product-card__image"
                  />
                  {hoveredProduct === product.id && (
                    <div className="product-card__overlay">
                      <div className="product-card__info">
                        <h3 className="product-card__name">{product.name}</h3>
                        <p className="product-card__brand">{product.country}</p>
                        <p className="product-card__size">
                          {product.size.join(", ")}
                        </p>
                        <p className="product-card__price">
                          HK${product.price}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </body>
  );
}

export default Shop;
